import React from "react";
import style from './css/OurTeam.module.css'
import ContactUs from "./ContactUs";
import WhatsApp from "./WhatsApp";

function OurTeam() {
  document.title= 'Sky Computer Education | Our Team';
  const ourTeam = [
    {
      id: 1,
      name: "Amit Sir",
      post: "Director",
      img: "./img/amit-sir.jpg",
      facebook: "https://www.facebook.com/skycomputereducationdbg/",
      instagram: "https://www.instagram.com/skycomputereducation/",
      linkedin: "",
      telegram: "https://telegram.me/skycomputereducation",
    },
    {
      id: 2,
      name: "Zeesan Sir",
      post: "Incharge",
      img: "./img/zeeshan.jpg",
      facebook: "https://www.facebook.com/skycomputereducationdbg/",
      instagram: "https://www.instagram.com/skycomputereducation/",
      linkedin: "",
      telegram: "https://telegram.me/skycomputereducation",
    },
    {
      id: 3,
      name: "Ravi Sir",
      post: "Programmer",
      img: "./img/ravi.jpeg",
      facebook: "https://www.facebook.com/sndeboy?mibextid=ZbWKwL",
      instagram: "https://www.instagram.com/seraviraj/?igshid=Mzc0YWU1OWY%3D",
      linkedin: "https://www.linkedin.com/in/ravi-raj-64a560265/",
      telegram: "https://telegram.me/seraviraj",
    },
    {
      id: 4,
      name: "Raman Sir",
      post: "Graphics Designer",
      img: "./img/raman.jpg",
      facebook: "https://www.facebook.com/skycomputereducationdbg/",
      instagram: "https://www.instagram.com/skycomputereducation/",
      linkedin: "",
      telegram: "https://telegram.me/skycomputereducation",
    },
    {
      id: 5,
      name: "Gautam Sir",
      post: "Computer Teacher",
      img: "./img/gautam.jpeg",
      facebook: "https://www.facebook.com/skycomputereducationdbg/",
      instagram: "https://www.instagram.com/skycomputereducation/",
      linkedin: "",
      telegram: "https://telegram.me/skycomputereducation",
    }
  ];
  return (
    <>
      <div className="container-fluid " style={{background:'#2d2d2f'}}>
        <div className="container">
          <div className="row justify-content-center">
          <h2 className={`text-center text-warning p-3 ${style.heading}`}> Our Team</h2>
            {ourTeam.map((e) => (
              <div className="col-lg col-md col-sm mb-5" key={e.id}>
                <div
                  className={`${style.card} card bg-dark text-light`}
                >
                  <img src={e.img} className="card-img-top d-block" alt="..." style={{height:'200px'}} />
                  <div className="card-body" style={{margin:'auto'}}>
                    <h5 className="card-title text-center">{e.name}</h5>
                    <p className="card-text text-center">{e.post}</p>
                    <a href={e.facebook} className="m-2 text-decoration-none">
                      {" "}
                      <i className={`${style.s_icon} fa-brands fa-facebook`}></i>
                    </a>
                    <a href={e.instagram} className="m-2 text-decoration-none">
                      {" "}
                      <i className={`${style.s_icon} fa-brands fa-instagram`}></i>
                    </a>
                    <a href={e.linkedin} className="m-2 text-decoration-none">
                      {" "}
                      <i className={`${style.s_icon} fa-brands fa-linkedin`}></i>
                    </a>
                    <a href={e.telegram} className="m-2 text-decoration-none">
                      {" "}
                      <i className={`${style.s_icon} fa-brands fa-telegram`}></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ContactUs/>
      <WhatsApp/>
    </>
  );
}

export default OurTeam;
